import { useAtomValue, useSetAtom } from 'jotai';
import { useCallback } from 'react';

import { tvGuideRecordingStatusUpdatesAtom } from '@smart-tv/atoms';
import { LiveTvChannel, StreamType } from '@smart-tv/typings/content';

import useStream from './use-stream';

const usePlayerRecording = (channel?: LiveTvChannel) => {
  const { streamType } = useStream();
  const recordingStatusUpdates = useAtomValue(tvGuideRecordingStatusUpdatesAtom);
  const setRecordingStatusUpdates = useSetAtom(tvGuideRecordingStatusUpdatesAtom);

  const currentProgram = channel?.currentProgram;
  const sid = currentProgram?.sid;
  const eventId = currentProgram?.eventId;

  const canRecord =
    streamType === StreamType.LiveStream &&
    Boolean(currentProgram?.recordable) &&
    sid !== undefined &&
    eventId !== undefined;

  const isRecording =
    canRecord &&
    (recordingStatusUpdates.programs[`${sid}:${eventId}`]?.isRecording ??
      currentProgram?.recording ??
      false);

  const setIsRecording = useCallback(
    (recording: boolean) => {
      if (sid === undefined || eventId === undefined) return;

      setRecordingStatusUpdates((current) => ({
        ...current,
        programs: {
          ...current.programs,
          [`${sid}:${eventId}`]: { isRecording: recording, sid }
        }
      }));
    },
    [setRecordingStatusUpdates, sid, eventId]
  );

  return { canRecord, isRecording, setIsRecording, sid, eventId };
};

export default usePlayerRecording;
